<template>
    <div class="streamMedia-container">
        <headline @search="headSearch" :params="headLines" :isSearchResult="isSearchResult" :searchKeyWord="keyWord"></headline>
        <div :style="'font-size:'+fontSize+'px'" class="streamMedia-content">
            <div v-if="!isSearchResult" ref="bg" class="bg">
                <img src="../../assets/img/streamMedia/bgWord.png" alt="">
                <div @click="showSearchBox = true"  v-click-outside="closeSearchBox" class="input-container">
                    <img src="../../assets/img/streamMedia/search.png" alt="">
                    <input v-model="keyWord" placeholder="搜索您需要的素材" @keydown.enter="getKeyWord();navigateSearch(keyWord)" type="text">
                    <div v-show="showSearchBox" class="searchBox-container">
                        <div class="histroy-list">
                            <div class="title">
                                <p>历史记录</p>
                                <p @click="delKeyWord">清空</p>
                            </div>
                            <ul>
                                <li @click="navigateSearch(item.title)" v-for="(item,index) in searchBox.userRes" :key="index">{{item.title}}</li>
                            </ul>
                        </div>
                        <div class="line"></div>
                        <div class="search-list">
                            <div class="title">
                                <p>大家都在搜</p>
                            </div>
                            <ul>
                                 <li @click="navigateSearch(item.title)" v-for="(item,index) in searchBox.totalRes" :key="index">{{item.title}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn">
                <div v-show="isSearchResult" class="resultNum">
                    <p @click="datePicker = '';keyWord = '';filterType = 0;showSearchBox = false;page.pageIndex = 1;isSearchResult = false;getList()" class="home">媒资首页</p>
                    <p style="margin-left: 8px">></p>
                    <p>“</p>
                    <p class="bold">{{keyWord}}</p>
                    <p>”共{{page.total}}个结果</p>
                </div>
                <div class="resultSearch">
                    <div class="left">
                        <p @click="filterType = index;page.pageIndex=1;getList()" v-for="(item,index) in filterTypeList" :key="index" :class="{on: filterType === index}">{{item}}</p>
                    </div>
                    <date-picker v-show="isSearchResult" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm>
                        </date-picker>
                </div>
                <!-- <div class="right">
                    
                </div> -->
            </div>
            <div style="width: 12.62em; margin: 0 auto;">
                <empty :mTop="30" v-if="list && list.length === 0 && !waiting" :msg="'暂无素材'" />
                <skeleton v-show="waiting" mediaType="media"></skeleton>
            </div>
            <ul v-show="!waiting" class="list-content" ref="list">
                <li @mouseenter="showTwoBtn(index)" @mouseleave="hideTwoBtn(index)" v-for="(item,index) in list" :key="index" :style="'height:'+itemHeight+'px'" :class="{list: true, on: item.status, border: item.editStatus}">
                    <div :style="'height:'+itemImgHeight+'px'" class="cover">
                    <!-- <div class='verify-success verify-item' v-if="item.has_audit&&item.has_audit==1&&+item.type === 2">
                        <img class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
                        技审通过
                    </div>

                    <div class='verify-fail verify-item' v-if="item.has_audit&&item.has_audit==2&&+item.type === 2">
                        <img class="verify-logo" src="@assets/img/common/verify-fail-logo.svg">
                        技审未通过
                    </div> -->
                    <div @click="openDetail(item.type, item.id, index)" class="bg" v-if="item.type-0 === 1 || item.type-0 === 2" :style="{'background-image': `url(${item.cover || defaultImg})`}"></div>
                    <div @click="openDetail(item.type, item.id, index)" class="bg" v-if="item.type-0 === 3" :style="{'background-image': `url(${item.cover || defaultMedia})`}"></div>
                    <img @click="openDetail(item.type, item.id, index)" v-show="item.type-0 === 2 || item.type-0 === 3" class="playBtn" src="@assets/img/index/play.svg" alt="">
                    <!-- <img v-show="item.is_new-0 === 1&&item.status === false" :class="{newIcon: true, on: item.editStatus}" src="@assets/img/common/new-bold.svg" alt=""> -->
                    <!-- <div @click="item.status=!item.status;calcSelect();setSelected(item)" :class="{selectIcon: true, on: item.status, show: item.editStatus}"></div>
                    <div @click="item.showMenu = !item.showMenu;checkPos(index)" :class="{pointIcon: true, on: item.showMenu}"></div>
                    <ul v-show="item.showMenu" class="pointList">
                        <li>
                        <span>创建</span>
                        <i v-show="$store.state.create.material||$store.state.create.report||$store.state.create.publish"></i>
                        <div :class="{left: item.showLeft}">
                            <ul>
                            <li v-show="$store.state.create.material" @click="navigate('material',item.id)">
                                <span>上传线索</span>
                            </li>
                            <li v-show="$store.state.create.report" @click="navigate('report',item.id)">
                                <span>创建报道</span>
                            </li>
                            <li v-show="$store.state.create.publish" @click="navigate('publish',item.id)">
                                <span>创建发布</span>
                            </li>
                            </ul>
                        </div>
                        </li>
                        <li v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role) && item.type != 1 && item.type != 3">
                        <span>下载</span>
                        <i></i>
                        <div :class="{left: item.showLeft}">
                            <ul>
                            <li @click="downloadSource(item,0)" v-if="item.detail.has_low_quality_download_role">
                                <span>800K码流下载</span>
                            </li>
                            <li @click="downloadSource(item,1)" v-if="item.detail.has_high_quality_download_role">
                                <span>原始码流下载</span>
                            </li>
                            </ul>
                        </div>
                        </li>
                        <li @click="downloadSource(item,1)" v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role) && item.type == 1">
                        <span>下载</span>
                        </li>
                        <li @click="downloadSource(item,1)" v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role) && item.type == 3">
                        <span>下载</span>
                        </li>
                        <li v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type != 1 && item.type != 3">
                        <span>复制</span>
                        <i></i>
                        <div :class="{left: item.showLeft}">
                            <ul>
                            <li @click="copySource(item,0)" :class="{un: !item.detail.low_quality_copy_available}" v-if="item.detail.has_low_quality_copy_role">
                                <span>800K码流复制</span>
                            </li>
                            <li @click="copySource(item,1)" v-if="item.detail.has_high_quality_copy_role">
                                <span>原始码流复制</span>
                            </li>
                            </ul>
                        </div>
                        </li>
                        <li @click="copySource(item,1)" v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type == 1">
                        <span>复制</span>
                        </li>
                        <li @click="copySource(item,1)" v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type == 3">
                        <span>复制</span>
                        </li>
                        <li style="margin: 0;justify-content: center" @click="rename(item)">
                        <span style="margin: 0">重命名</span>
                        </li>
                        <li @click="delDetail(item.id)">
                        <span>删除</span>
                        </li>
                        <li v-if="item.type == 2 && $store.state.quickEdit" @click="edit(item,item.type)">
                        <span>编辑</span>
                        </li>
                        <li v-if="item.type != 2" @click="edit(item,item.type)">
                        <span>编辑</span>
                        </li>
                        <li v-if="$store.state.quickEdit" @click="useDetail(item.id)">
                        <span>选用</span>
                        </li>
                    </ul> -->
                    <!-- <div class="mask">
                        <div @click="delDetail(item.id)" class="whiteBg del">
                        <i></i>
                        </div>
                        <div @click="openDetail(item.type, item.id, index)" class="whiteBg detail">
                        <i></i>
                        </div>
                    </div> -->
                    </div>
                    <div :class="{detail: true,on: item.editStatus}">
                    <p @click="openDetail(item.type, item.id, index)" class="title">
                        <img v-show="item.type-0 === 1" src="@assets/img/common/imgIcon.svg" alt="img">
                        <img v-show="item.type-0 === 3" src="@assets/img/common/audioIcon.svg" alt="img">
                        <img v-show="item.type-0 === 2" src="@assets/img/common/videoIcon.svg" alt="img">
                        <span v-html="item.title"></span>
                    </p>
                    <div :class="{detail: true, on: item.editStatus}">
                        <p class="clock">
                            <img src="@assets/img/material/clockIcon.svg" alt="">
                            <span>{{item.update_time}}</span>
                        </p>
                    </div>
                    </div>
                </li>
                <li class="fillItem" :style="{height: 0, width: `${fillWidth}px`}"></li>
            </ul>
            <div v-show="showLoad" class="loadingIcon"></div>
            <pages style="margin-top: 6px;padding: 0;justify-content: center" :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
        </div>
    </div>
</template>

<script>
import headline from "@components/headline";
import common from "@common/common";
import { apis } from "@common/config";
import vClickOutside from "v-click-outside";
import pages from "@components/pages";
import empty from "@components/empty";
import skeleton from "@components/skeleton";
import DatePicker from "vue2-datepicker";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        pages,
        empty,
        DatePicker,
        skeleton,
        headline
    },
    data() {
        return {
            controller: null,
            showLoad: false,
            showSearchBox: false,
            waiting: true,
            headLines: {
                title: "EPM媒资",
                showLink: false,
                filter: false
            },
            fontSize: 100,
            defaultImg: require("@assets/img/common/default.png"),
            defaultMedia: require("@assets/img/common/audioMask.jpg"),
            list: [],
            saveList: [],
            filterTypeList: ['全部', '图片', '视频', '音频'],
            filterType: 0,
            fillWidth: 0,
            itemHeight: 0,
            itemImgHeight: 0,
            keyWord: '',
            start: '',
            end: '',
            quickEdit: true,
            create: {
                interview: false,
                material: false,
                publish: false,
                report: false
            },
            page: {
                pageCount: 0,
                pageIndex: 1,
                pageSize: 100,
                total: 0
            },
            searchBox: {},
            isSearchResult: false,
            datePicker: ''
        }
    },
    watch: {
        datePicker: {
            deep: true,
            handler: function (n) {
                this.page.pageIndex = 1;
                this.start = common.stampToTime(n[0]);
                this.end = common.stampToTime(n[1]);
                this.getList();
            }
        },
        "$store.state.tag": function (e) {
            this.navigateSearch(e)
        }
    },
    methods: {
        changeList() {
            const scrolltop = document.documentElement.scrollTop;
            const scrollheight = document.documentElement.scrollHeight;
            const clientheight = document.documentElement.clientHeight;
            var timeout = null;
            if (scrolltop + clientheight >= scrollheight) {
                let list = this.saveList
                console.log(list.length)
                if(list.length > 0){
                    this.showLoad = true;
                    // if(timeout){
                    //     clearTimeout(timeout)
                    //     timeout = null
                    // }
                    timeout = setTimeout(() => {
                        this.list = this.list.concat(list.splice(0,20))
                        this.saveList = list
                        this.$nextTick(() => {
                            this.calcFillWidth();
                            this.showLoad = false;
                        })
                    }, 500);
                }else{
                    this.showLoad = false;
                }
            }
        },
        handleScroll() {
            this.$nextTick(() => {
                window.addEventListener('scroll', this.changeList)
            })
        },
        headSearch(title) {
            this.keyWord = title;
            this.page.pageIndex = 1;
            this.getList();
        },
        navigateSearch(title) {
            this.isSearchResult = true;
            this.showSearchBox = false;
            this.keyWord = title;
            this.page.pageIndex = 1;
            this.getList();
        },
        closeSearchBox() {
            this.showSearchBox = false;
        },
        openDetail(type, id, index) {
            let data = {
                type: type,
                id: id,
                create: this.create,
                canEdit: false,
                quickEdit: this.quickEdit,
                isStream: true
            };
            this.$materialBox(data);
        },
        getList() {
            if (this.controller) {
                this.controller.abort(); // 终止之前的请求
            }

            this.controller = new AbortController(); // 创建新的 AbortController
            const signal = this.controller.signal; // 获取信号
            this.waiting = true;
            let has_file = -1
            if(this.filterType == 0){
                has_file = -1
            }else{
                has_file = this.filterType
            }
            let data = {
                key_words: this.keyWord,
                page: this.page.pageIndex,
                pagesize: this.page.pageSize,
                has_file: has_file,
                start: this.start,
                end: this.end
            };
            common.myFetch(apis.streammediaList, {data: data,signal: signal}).then(res => {
                if (res) {
                    console.log(res)
                    this.$set(
                        this.page,
                        "pageCount",
                        common.calculatePage(res.page.row_count - 0, this.page.pageSize)
                    );
                    this.$set(this.page, "total", res.page.row_count - 0);
                    // this.list = res.list.slice(0, 20)
                    let list = res.list
                    this.list = list.splice(0,20)
                    console.log(this.list)
                    this.saveList = list
                    this.waiting = false;
                    this.$nextTick(() => {
                        console.log(this.saveList)
                        this.calcFillWidth();
                    })
                }
            });
        },
        getKeyWord() {
            let data = {};
            common.myFetch(apis.streammediaKeywords, data).then(res => {
                if (res) {
                    console.log(res)
                    this.searchBox = res
                }
            });
        },
        delKeyWord() {
            let data = {};
            common.myFetch(apis.delStreammediaKeywords, data).then(res => {
                if (res) {
                    console.log(res)
                    this.searchBox.userRes = []
                }
            });
        },
        showTwoBtn(index) {
            this.$set(this.list[index], 'isOn', true)  
        },
        hideTwoBtn(index) {
            if(!this.list[index].isSelected){
                this.$set(this.list[index], 'isOn', false)
            }  
            this.$set(this.list[index], 'showMenu', false)
            this.$set(this.list[index], 'showLeft', false)
        },
        recalc() {
            var clientWidth = document.documentElement.clientWidth;

            if (!clientWidth) {

                return;
            }

            var p = 100 * (clientWidth / 1334);

            if(p<97.3){
                p=97.3
            }else if(p>110){
                p=110
            }

            this.fontSize = p

            // console.log(this.$refs.bg.getBoundingClientRect().width)

            // if(this.$refs.bg.getBoundingClientRect()){
            //     this.bgHeight = this.$refs.bg.getBoundingClientRect().width * 314 / 1262
            // }
        },
        calcFillWidth() {
            // console.log(999)
            // 计算填充元素宽度
            const list = this.$refs.list;
            if (!list || !list.getBoundingClientRect()) return;
            const listWidth = list.getBoundingClientRect().width;
            let fillWidth = 0;
            const itemWidth = 240; // item dom宽度
            const itemGap = 16; //item 边距
            const listGap = 16; // list左右边距
            const countsPerPage = this.list.length || 20; //每页的item数量
            const containerWidth = listWidth - listGap; //容器实际宽度（dom宽度 - 左右padding）
            const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap)); //每行item数量
            const countsLastLine = countsPerPage % countsPerRow || countsPerRow; //最后一行的item数量
            const itemRatio = 284.5 / 255;
            const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap;
            const itemHeightNow = itemWidthNow * itemRatio;

            fillWidth =
                countsPerRow === countsLastLine
                ? 0
                : (countsPerRow - countsLastLine) * (itemWidthNow + itemGap);

            this.fillWidth = fillWidth;
            this.itemHeight = (((listWidth/countsPerRow)-14)*9/16)+116;
            this.itemImgHeight = (((listWidth/countsPerRow)-14)*9/16);
            // this.itemHeight = itemHeightNow;
            // console.log('list', itemWidthNow, itemHeightNow, countsPerRow, fillWidth)
        },
        addCalcEvent() {
            // 监听list dom宽度变化
            window.addEventListener("resize", () => {
                this.calcFillWidth();
            });
        }
    },
    mounted() {
        this.defaultImg = this.$_syscfg.default_img
        this.defaultMedia = this.$_syscfg.default_media

        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

        window.addEventListener(resizeEvt, this.recalc, false);

        document.addEventListener('DOMContentLoaded', this.recalc, false);

        this.recalc()

        this.getList()

        this.getKeyWord()

        this.addCalcEvent()
    },
    created() {
        this.create = this.$store.state.create;
        this.quickEdit = this.$store.state.quickEdit;
        this.handleScroll()
    }
}
</script>

<style lang="less" scoped>
    @import '../../assets/css/global.less';
    .streamMedia-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        min-width: 1280px;
        min-height: 100vh;
        background: #FAFBFC;

        .streamMedia-content {
            display: flex;
            flex-direction: column;
            width: 100%;
            flex: 1;
            padding: 0.3em 0.36em 0.7em;
            background: #FAFBFC;
            box-sizing: border-box;

            .bg {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 12.62em;
                height: 3.14em;
                max-width: 100%;
                background: url('../../assets/img/streamMedia/bg.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                margin: 0 auto 0.32em;
                // margin-bottom: 0.32em;
                // margin: 0.3em auto 0.35em;
                padding: 0;

                &>img {
                    width: 3.23em;
                    height: 0.30em;
                    margin-bottom: 0.3em;
                }

                .input-container {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 5.82em;
                    height: 0.5em;
                    max-width: 100%;
                    background: #FFFFFF;
                    border-radius: 0.06em;
                    padding: 0 0.2em;
                    box-sizing: border-box;
                    // overflow: hidden;

                    &>img {
                        width: 0.22em;
                        height: 0.22em;
                        margin-right: 0.14em;
                    }

                    input {
                        flex: 1;
                        height: 100%;
                        font-size: 0.14em;
                    }

                    ::placeholder{  //通过这个设置 
                        color: #0B131F
                    }

                    .searchBox-container {
                        position: absolute;
                        top: 0.54em;
                        left: 0;
                        z-index: 99;
                        display: flex;
                        flex-direction: column;
                        width: 5.82em;
                        padding: 0.2em 0.2em 0.1em;
                        background: #FFFFFF;
                        border-radius: 0.06em;
                        box-shadow: 0px 0px 20px 0px rgba(215, 222, 227, 0.39), 0px 26px 90px 0px rgba(51, 59, 69, 0.1);
                        box-sizing: border-box;

                        .histroy-list {
                            display: flex;
                            flex-direction: column;
                            width: 100%;

                            .title {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                justify-content: space-between;
                                margin-bottom: 10px;

                                p {
                                    display: block;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #829191;

                                    &:nth-last-of-type(1) {
                                        user-select: none;
                                        cursor: pointer;
                                    }
                                }
                            }

                            ul {
                                display: flex;
                                flex-direction: row;
                                flex-wrap: wrap;

                                li {
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #0B131F;
                                    margin-right: 20px;
                                    margin-bottom: 10px;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }
                        }

                        .line {
                            width: 100%;
                            height: 1px;
                            background: #F0F0F0;
                            margin-bottom: 19px;
                        }

                        .search-list {
                            .title {
                                margin-bottom: 10px;

                                p {
                                    display: block;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #829191;
                                }
                            }

                            ul {
                                display: flex;
                                flex-direction: row;
                                flex-wrap: wrap;

                                li {
                                    min-width: 68px;
                                    font-size: 14px;
                                    min-height: 30px;
                                    line-height: 30px;
                                    color: #0B131F;
                                    margin-right: 10px;
                                    margin-bottom: 10px;
                                    user-select: none;
                                    cursor: pointer;
                                    padding: 0 20px;
                                    border-radius: 4px;
                                    background: rgba(185,195,195,0.2);
                                    box-sizing: border-box;
                                }
                            }
                        }
                    }
                }
            }

            .resultNum {
                // width: 12.62em;
                // margin: 0.3em auto 0.3em;
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 14px;
                line-height: 20px;
                color: #829191;
                font-weight: bold;

                p {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
            }

            .btn {
                display: flex;
                flex-direction: column;
                // justify-content: space-between;
                // align-items: center;
                width: 12.62em;
                margin: 0 auto 0.35em;
                // margin-bottom: 0.35em;

                .resultNum {
                    // width: 12.62em;
                    margin: 0 0 30px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    font-size: 14px;
                    line-height: 20px;
                    color: #829191;
                    font-weight: bold;

                    p {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        &.home {
                            user-select: none;
                            cursor: pointer;
                        }

                        &.bold {
                            color: #0B131F;
                        }
                    }
                }

                .resultSearch {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;

                    .left {
                        display: flex;
                        flex-direction: row;
                        align-items: flex-end;
                        p {
                            font-size: 14px;
                            color: #829191;
                            line-height: 20px;
                            margin-right: 30px;
                            user-select: none;
                            cursor: pointer;

                            &.on {
                                font-size: 16px;
                                color: #00B789;
                                line-height: 22px;
                                font-weight: bold;
                                // margin-right: 24px;
                            }
                        }
                    }
                }
            }

            .list-content {
                display: flex;
                flex-direction: row;
                justify-content: center;
                flex-wrap: wrap;
                width: 12.62em;
                margin: 0 auto;

                .list {
                display: flex;
                flex-direction: column;
                // min-width: 242px;
                min-width: 240px;
                flex: 1;
                // width: 242px;
                height: 233px;
                border-radius: 4px;
                // border: 1px solid #dcdcdc;
                margin: 0 8px 42px;
                box-sizing: border-box;

                &.on {
                    // background-color: rgba(185, 195, 195, 0.2);
                    background: #F3FAF8;
                    border: 1px solid @green;
                    box-sizing: border-box;

                    &>.detail {
                        padding: 12px 10px;
                        box-shadow: none;
                        box-sizing: border-box;
                    }
                }

                &:hover {
                    // border: 1px solid @green;
                    box-shadow: 0px 0px 20px 0px rgba(215, 222, 227, 0.39), 0px 26px 90px 0px rgba(51, 59, 69, 0.1);
                    box-sizing: border-box;
            
                    &>.detail {
                        padding: 12px 10px;
                        box-shadow: none;
                        box-sizing: border-box;
                    }
                }

                &.border {
                    border: 2px solid @green;
                    box-sizing: border-box
                }

                .cover {
                    position: relative;
                    display: flex;
                    width: 100%;
                    flex: 1;
                    // position: relative;
                    border-radius: 4px;
                    // overflow: hidden;    
                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                    user-select: none;
                    cursor: pointer;

                    &:hover {
                    .mask {
                        display: flex;
                    }
                    .selectIcon {
                        display: block;
                    }
                    .pointIcon {
                        display: block;
                    }
                    }

                    .verify-item {
                    position: absolute;
                    right: 0;
                    bottom: 6px;
                    background-color: rgba(@green, 0.5);
                    line-height: 18px;
                    border-radius: 50px 0 0 50px;
                    z-index: 1;
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    font-size: 10px;
                    font-weight: 700px;
                    color: white;
                    padding: 0 8px;
                    &.verify-fail {
                        background-color: rgba(#ff3e53, 0.5);
                    }
                    img {
                        width: 11px;
                        margin-right: 4px;
                    }
                    }
                    .bg {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: center;
                    border-radius: 4px;

                    &:hover {
                        border-radius: 4px 4px 0 0;
                    }
                    }

                    .mask {
                    display: none;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.6);
                    
                    .whiteBg {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 36px;
                        height: 36px;
                        background: #FFFFFF;
                        border-radius: 50%;
                        margin-right: 28px;
                        &:nth-last-of-type(1) {
                        margin-right: 0;
                        }

                        &:hover {
                        background: #41b48c;
                        }

                        &.del {
                        &:hover {
                            i {
                            background: url('../../assets/img/material/indexDelWhite.svg') no-repeat;
                            }
                        }
                        i {
                            display: block;
                            width: 20px;
                            height: 20px;
                            background: url('../../assets/img/material/indexDel.svg') no-repeat;
                            background-position: center;
                            background-size: 100% 100%;
                        }
                        }
            
                        &.detail {
                        &:hover {
                            i {
                            background: url('../../assets/img/material/indexDetailWhite.svg') no-repeat;
                            }
                        }
                        i {
                            display: block;
                            width: 20px;
                            height: 20px;
                            background: url('../../assets/img/material/indexDetail.svg') no-repeat;
                            background-position: center;
                            background-size: 100% 100%;
                        }
                        }
                    }
                    }

                    .playBtn {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    width: 40px;
                    height: auto;
                    }

                    .newIcon {
                    position: absolute;
                    top: 6px;
                    right: 7px;

                    &.on {
                        display: none;
                    }
                    }

                    .selectIcon {
                    display: none;
                    position: absolute;
                    top: 8px;
                    left: 9px;
                    z-index: 9;
                    width: 24px;
                    height: 24px;
                    border-radius: 12px;
                    background-color: rgba(90, 90, 90, 0.7);
                    user-select: none;
                    cursor: pointer;

                    &.show {
                        display: block;
                    }
                    
                    &::after {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        margin-left: -7px;
                        margin-top: -5.5px;
                        content: "";
                        display: block;
                        width: 14px;
                        height: 11px;
                        background: url("../../assets/img/material/checked.svg") no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    &.on {
                        display: block;
                        background-color: @green;
                        &::after {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        margin-left: -7px;
                        margin-top: -5.5px;
                        content: "";
                        display: block;
                        width: 14px;
                        height: 11px;
                        background: url("../../assets/img/material/checked.svg") no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        }
                    }
                    }

                    .pointIcon {
                    display: none;
                    position: absolute;
                    top: 6px;
                    right: 5px;
                    z-index: 9;
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/img/material/point.svg") no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    user-select: none;
                    cursor: pointer;
            
                    &.on {
                        width: 24px;
                        height: 24px;
                        background: url("../../assets/img/material/pointOn.svg") no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }
                    }

                    .pointList {
                    position: absolute;
                    top: 36px;
                    right: -40px;
                    z-index: 99;
                    display: flex;
                    flex-direction: column;
                    min-width: 120px;
                    height: fit-content;
                    background: #FFFFFF;
                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                    border-radius: 4px;
            
                    &>li {
                        position: relative;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        font-size: 13px;
                        color: #030F0F;
                        font-weight: bold;
            
                        &>div {
                        display: none;
                        position: absolute;
                        top: 0;
                        left: 120px;
                        width: 122px;
            
                        ul {
                            float: right;
                            min-width: 120px;
                            overflow: hidden;
                            background: #FFFFFF;
                            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                            border-radius: 4px;
                            box-sizing: border-box;
            
                            li {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            width: 100%;
                            height: 40px;
                            line-height: 40px;
                            font-size: 13px;
                            color: #030F0F;
                            font-weight: bold;

                            &.un {
                                color: #CCC;
                            }
            
                            span {
                                margin: 0;
                            }
            
                            &:hover {
                                background: rgba(65, 180, 140, 0.1);
                                color: #00B889;
                            }
                            }
                        }
            
                        &.left {
                            left: -122px;
            
                            ul {
                            float: left;
                            }
                        }
                        }
                        
                        span {
                        display: block;
                        margin-left: 47px;
                        }
            
                        i {
                        display: block;
                        width: 11px;
                        height: 15px;
                        background: url("../../assets/img/material/rightArrow.svg") no-repeat;
                        background-position: center;
                        background-size: 100% 100%;
                        // margin-right: 10px;
                        user-select: none;
                        cursor: pointer;
                        margin: 0 14px 0 0;
                        // margin-right: 14px;
                        }
            
                        &:hover {
                        background: rgba(65, 180, 140, 0.1);
                        color: #00B889;
            
                        &>div {
                            display: block;
                        }
            
                        i {
                            display: block;
                            width: 11px;
                            height: 15px;
                            background: url("../../assets/img/material/rightArrowOn.svg") no-repeat;
                            background-position: center;
                            background-size: 100% 100%;
                            // margin-right: 10px;
                            user-select: none;
                            cursor: pointer;
                            margin: 0 14px 0 0;
                            // margin-right: 14px;
                        }
                        }
                    }
                    }
                }

                & > .detail {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 100%;
                    height: 116px;
                    // padding: 10px 10px 12px;
                    padding: 12px 0;
                    border-radius: 0 0 4px 4px;
                    box-sizing: border-box;

                    &.on {
                        padding-bottom: 20px;
                        box-sizing: border-box;
                    }

                    .title {
                        font-size: 18px;
                        height: 48px;
                        min-height: 48px;
                        line-height: 24px;
                        font-weight: bold;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        word-break: break-all;
                        cursor: pointer;
                        user-select: none;
                        &:hover {
                            color: #41b48c;
                        }
                        img {
                            vertical-align: middle;
                            margin-right: 4px;
                        }
                    }

                    .detail {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        flex-wrap: wrap;

                        &.on {
                            display: none;
                        }
                    
                        p {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 14px;
                            line-height: 18px;
                            color: #b9c3c3;
                            margin-bottom: 4px;
                            min-width: 50%;

                            &.clock {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                font-weight: bold;
                                font-family: Arial, sans-serif;

                                img {
                                    margin-right: 5px;
                                }

                                span {
                                    font-size: 14px;
                                    color: #B9C3C3;
                                }
                            }

                            &.share {
                            position: relative;
                            display: flex;
                            justify-content: flex-end;
                            cursor: pointer;
                            min-width: 28%;

                            &:hover {
                                .tips {
                                display: block;
                                }
                            }

                            .tips {
                                position: absolute;
                                display: none;
                                // margin: 0 0 0 -142px;
                                top: 24px;
                                left: -279px;
                                // left: 50%;
                                // margin-left: -170px;
                                border-radius: 4px;
                                overflow: hidden;
                                background-color: rgba(5, 15, 15, 0.8);
                                // width: 340px;
                                width: 418px;
                                height: auto;
                                // padding: 5px 20px;
                                padding: 13px 20px;
                                line-height: 20px;
                                box-sizing: border-box;
                                z-index: 5;
                                .tip {
                                height: 20px;
                                // margin: 5px 0;
                                display: flex;
                                align-items: center;
                                font-size: 14px;
                                color: @dateColor;
                                margin-bottom: 10px;

                                &:nth-last-of-type(1) {
                                    margin-bottom: 0;
                                }
                                img {
                                    margin-right: 10px;
                                }
                                .tiptitle {
                                    color: #fff;
                                    flex: 1;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                                .tiper {
                                    width: 42px;
                                    flex-shrink: 0;
                                    margin-left: 10px;
                                    margin-right: 10px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                                .tiptime {
                                    flex-shrink: 0;
                                    // width: 72px;
                                }
                                &:hover {
                                    text-decoration: underline;
                                }
                                }
                                &:hover {
                                display: block;
                                }
                            }
                            }

                            &:nth-last-of-type(1) {
                            margin-bottom: 0;
                            }
                        }
                    }

                    .edit {
                    display: none;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 30px;
                    box-sizing: border-box;

                    &.on {
                        display: flex;
                    }
                    
                    div {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        cursor: pointer;
                        user-select: none;

                        img {
                        margin-right: 10px;
                        }

                        span {
                        font-size: 14px;
                        line-height: 18px;
                        color: #41b48c;
                        }
                    }

                    .line {
                        width: 1px;
                        height: 20px;
                        background: #e6e6e6;
                    }
                    }
                }

                // &:hover {
                //   border: 2px solid @green;
                //   box-sizing: border-box;

                //   .detail {
                //     padding-bottom: 20px;
                //     box-sizing: border-box;

                //     .detail {
                //       display: none;
                //     }

                //     .edit {
                //       display: flex;
                //     }
                //   }

                //   .newIcon {
                //     display: none;
                //   }

                //   .selectIcon {
                //     display: block;
                //   }
                // }
                }
            }
        }

        .loadingIcon {
            width: 50px;
            height: 50px;
            background: url('../../assets/img/streamMedia/load.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin: 0 auto 40px;
            animation: rotate360 1.2s linear infinite;
        }

        @keyframes rotate360 {
            0%{
                transform: rotate(0deg);
            }
            100%{
                transform: rotate(360deg);
            }
        }
    }
</style>

<style lang="less">
    .streamMedia-container {
        .headline {
            background-color: #FFFFFF !important;
            box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.05);
            border-bottom: 1px solid #EBEDF8;
            box-sizing: border-box;
        }

        .logo {
            box-shadow: none;
        }

        .mx-input-wrapper {
            background: rgba(185, 189, 195, 0.15);
            border: none;
            outline: none;
            box-sizing: border-box;

            input {
                border: none;
                outline: none;

                &::placeholder {
                    color: #829191;
                    padding-left: 45px;
                    box-sizing: border-box;
                }
            }
        }

        .title {
            em {
                color: #41b48c;
                font-style: normal;
            }
        }
    }
</style>